import { SITES_TEMPLATE_BASE } from "./constants/templates";
import { isObject } from "./objects";

export const isEcomTemplate = (template) => template && template.includes(SITES_TEMPLATE_BASE.ECOM);

export const getTemplate = (obj) => (isObject(obj) && obj["mgnl:template"] ? obj["mgnl:template"] : null);
